const EventBus = window.VueEventBus
import LocationCheckoutMixin from '../../../components/_mixins/location-checkout'

export default {
  name: 're-header-mini-cart',
  mixins: [LocationCheckoutMixin],
  props: {
    containerClass: {default: 're-mini-cart'},
    countClass: {default: 're-cart-count'},
    iconClass: {default: 're-cart-icon'},
  },
  computed: {
    visibleCartItemsCount() {
      return (_.reject(this.currentCartItems || {}, (i) => i.attributes.skipCartCount)).length
    }
  }
}
